import React, { useContext } from 'react';
import { CgAdd } from 'react-icons/cg';
import { Link } from 'react-router-dom';
import AddressCard from '../../Components/AddressCard/AddressCard';
import Button from '../../Components/Button/Button';
import { Context } from '../../Context/Context';
import styles from './Address.module.scss';

const Address = () => {
  const { state: { address: addressList, defaultAddress: { id: defId } } } = useContext(Context);
  return (
    <div className={styles.container}>
      <h1>Deliver To</h1>
      <div className={styles.addressContainer}>
        {addressList.map(({
          id, firstName, lastName, address1, state, pin, phone,
        }) => (
          <AddressCard
            id={id}
            fullName={`${firstName} ${lastName}`}
            address={`${address1}, ${state.slice(0, 2).toUpperCase()} ${pin}, India`}
            phoneNumber={`(+91) ${phone}`}
            checkbox={id === defId}
          />
        ))}
        <Link to="/add-address" className={styles.linkStyle}>
          <div className={styles.newAddress}>
            <CgAdd />
            <div>ADD NEW ADDRESS</div>
          </div>
        </Link>
        <Link to="/checkout" className={styles.linkStyle}>
          <Button>Proceed</Button>
        </Link>
      </div>
    </div>
  );
};

export default Address;
